import { Component, useState} from "react";
import { useForm } from "../../../hooks/useForm";
import BaseModal from "../Base-modal";
import Input from "../../../blocks/Input";
import './user-modal.css'
import { useEffect } from "react";
import { useSnackbar } from 'notistack'
import { ajax } from "../../../scripts/helper";
import utils from "../../../scripts/utils";
import context from "../../../scripts/context";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs, { Dayjs } from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';







const Content = ({closeModal, showModal, onFilter, onChangeInput}) => {
    const {enqueueSnackbar} = useSnackbar()
    const [statusValue, setStatusValue] = useState()
    const [inputStatusValue, setInputStatusValue] = useState('');
    const [statusOptions, setStatusOptions] = useState([
        {label:'ACTIVE', data: {label: 'ACTIVE'}},
        {label: 'INACTIVE', data: {label: 'INACTIVE'}},
        {label: 'PENDING', data: {label: 'PENDING'}},
        {label: 'DELETED', data: {label: 'DELETED'}}
    ])
    const [inputFields, handleChange, setInputFields] = useForm(context.getUserInputFilter(),onChangeInput)
    
    const onUserInputFilter = (ins) => {
        setInputFields({
            ...ins
        })
    }
    context.addListenerUserInputFilter((inputs)=>{onUserInputFilter(inputs)})


    const [officeValue, setOfficeValue] = useState()
    const [inputOfficeValue, setInputOfficeValue] = useState('');
    const [officeOptions, setOfficeOptions] = useState([]);

    const fetchOffice = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.searchOfficeByCode(inputOfficeValue),
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        setOfficeOptions(res.data)
    }

    useEffect( () => {
        if(inputOfficeValue.trim()) fetchOffice()

     },[inputOfficeValue])

    // const [cityValue, setCityValue] = useState()
    // const [inputCityValue, setInputCityValue] = useState('');
    // const [cityOptions, setCityOptions] = useState([]);
    // const fetchCity = async() => {

    //     const response = await ajax({
    //         method: 'GET',
    //         url: utils.urls.searchCity(inputCityValue),
    //         hasToken: true,
    //         snackbar: enqueueSnackbar
    //     })
    //     console.log(response)

    //     if(!response) return

    //     setCityOptions(response.data)
    // }

    // useEffect( () => {
        
    //     if(inputCityValue.trim()) fetchCity()
            
    // }, [inputCityValue])

    


    return (
        <div className="inputs-container">
            <div>
                <label>username</label>
                <div className="field">
                    <Input inputField={inputFields.username}  onChange={handleChange}/>
                </div>
            </div>
            <div>
                <label>name</label>
                <div className="field">
                    <Input inputField={inputFields.name}  onChange={handleChange}/>
                </div>
            </div>
            <div>
                <label>email</label>
                <div className="field">
                    <Input inputField={inputFields.email}  onChange={handleChange} />
                </div>
            </div>
            <div>
                <label>mobile</label>
                <div className="field">
                    <Input inputField={inputFields.mobile}  onChange={handleChange} />
                </div>
            </div>
            <div>
                <label>office</label>
                <div className="field">
                <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={officeOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.offices.value}
                    noOptionsText="No office"
                    onChange={(event, newValue) => {
                        setOfficeValue(newValue?.id);
                        console.log(newValue, ' new valueeee')
                        setInputFields({
                            ...inputFields,
                            offices: {
                                ...inputFields.offices,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        onChangeInput({
                            ...inputFields,
                            offices: {
                                ...inputFields.offices,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        console.log(newValue)
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputOfficeValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}

                />
                </div>
            </div>
            <div style={{marginTop: "10px"}}>
                <label>status</label>
                <div className="field">
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={statusOptions}
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    value={inputFields.status.value}
                    onChange={(event, newValue) => {
                        console.log(newValue)
                        setInputFields({
                            ...inputFields,
                            status: {
                                ...inputFields.status,
                                selected: newValue?.label,
                                value: newValue?.label
                            }
                        })
                        onChangeInput({
                            ...inputFields,
                            status: {
                                ...inputFields.status,
                                selected: newValue?.label,
                                value: newValue?.label
                            }
                        })
                    }}
                />
                </div>
            </div>
        </div>
    )


}

const Footer = ({onFilter, closeModal, inputs}) => {
    // const [input, setInput] = useState(inputs)
    return (
        <div className="btns-container">
            <button className="clear" onClick={ () => {context.clearUserInputfilter(); onFilter(context.getUserInputFilter());closeModal()}}>Clear Filters</button>
            <button className="cancel" onClick={closeModal} >Cancel</button>
            <button className="apply" onClick={() => {onFilter(inputs);closeModal()}} >Apply Filters</button>
        </div>
    )
}
class UserModal extends Component {
    state = {
        open: false,
        inputs: {}
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})
    clearDate = () => { return ''}

    onChangeInputs = (inputs) => this.setState({inputs: inputs})

    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal} footer={Footer({onFilter: this.props.onFilter,closeModal: this.closeModal, inputs: this.state.inputs})}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                    onChangeInput={this.onChangeInputs}
                />
            </BaseModal>
        )
    }
}

export default UserModal